import "../../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import ModalDescription from "../../../components/modal/ModalDescription";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import WelcomeTemplateListView from "../../../components/welcomeScreen/WelcomeTemplateListView";
import templates from "../../../templates";

const SelectTemplatePage = props => {
  const group = templates.find(g => g.id === props.groupId);
  return [
    <ModalGroup key="content">
      <ModalRow>
        <ModalDescription>
          <span>Please select the closest template for your timeline:</span>
        </ModalDescription>
      </ModalRow>
      <WelcomeTemplateListView templates={group.templates} onTemplateClick={props.onTemplateClick} />
    </ModalGroup>
  ];
};

SelectTemplatePage.propTypes = {
  groupId: PropTypes.string.isRequired,
  onTemplateClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired
};

export default SelectTemplatePage;
